import form from '@/mixins/crud-form';
import utils from '@/utils';
export default {
  mixins: [form],
  data: function data() {
    return {
      api: {
        detail: 'SMS_MARKET_DETAIL',
        create: 'SMS_MARKET_CREATE',
        update: 'SMS_MARKET_UPDATE'
      },
      dialog: {
        width: '900px',
        height: '900px'
      }
    };
  },
  computed: {
    setting: function setting() {
      var _this = this;

      var h = this.$createElement;
      return [{
        prop: 'market_id',
        default: utils.cookies.get('market_id'),
        label: this.$t('market_id'),
        show: false,
        col: {
          span: 16
        },
        // render: () => <d2-dict-select name="form_market_id" vModel={ this.form.model.market_id } custom />
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.market_id,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "market_id", $$v);
              }
            }
          });
        }
      }, {
        prop: 'warn_phone',
        default: '',
        label: this.$t('warn_phone'),
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.warn_phone,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "warn_phone", $$v);
              }
            }
          });
        }
      }, {
        prop: 'warn_value',
        default: '',
        label: this.$t('warn_value'),
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input-number", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.warn_value,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "warn_value", $$v);
              }
            }
          });
        }
      }];
    }
  }
};